import { render, staticRenderFns } from "./MedicalStaff.vue?vue&type=template&id=5c896e50&scoped=true"
import script from "./MedicalStaff.vue?vue&type=script&lang=js"
export * from "./MedicalStaff.vue?vue&type=script&lang=js"
import style0 from "./MedicalStaff.vue?vue&type=style&index=0&id=5c896e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c896e50",
  null
  
)

export default component.exports